import {
  onSnapshot,
  query,
  collection,
  doc,
  updateDoc,
  setDoc,
  writeBatch
} from 'firebase/firestore'
import { db, dbOmit, generateId } from 'src/controllers/db'
import { IConference, IEntityType, ILesson } from 'shared/types'
import { receiveConferences } from 'src/model/actions'
import store from 'src/model/store'
import { addListener } from 'controllers/listeners'
import dayjs from 'dayjs'

export const dbFetchConferences = async () => {
  try {
    const q = query(collection(db, 'conferences'))
    const unsubscribe = onSnapshot(
      q,
      sn => {
        const res: Record<string, IConference> = {}
        sn.forEach(doc => {
          const p = doc.data() as IConference
          res[doc.id] = {
            ...p,
            id: doc.id,
            createdAt: +dayjs(p.createdAt || 0)
          }
        })
        store.dispatch(receiveConferences(res))
      },
      err => {
        console.log(`dbFethConferences error: ${err.message}`)
      }
    )
    addListener('conferences', unsubscribe)
  } catch (e) {
    console.error('dbFetchConferences error', e)
  }
}

export const dbUpdateConference = async (
  id: string,
  upd: Partial<IConference>
) => {
  try {
    console.log('dbUpdateConference', id, upd)
    const ref = doc(collection(db, 'conferences'), id)
    await updateDoc(ref, dbOmit(upd))
  } catch (e) {
    console.log('dbUpdateConference error', e)
  }
}

export const dbCreateConference = async () => {
  const id = generateId()
  const c: IConference = {
    id,
    title: 'Новая конференция',
    lessons: [],
    createdAt: +dayjs()
  }
  const ref = doc(collection(db, 'conferences'), id)
  await setDoc(ref, dbOmit(c))
  return id
}

export const dbDeleteConference = async (c: IConference) => {
  const batch = writeBatch(db)
  batch.delete(doc(collection(db, 'conferences'), c.id))
  if (c.lessons) {
    for (const lId of c.lessons) {
      batch.delete(doc(collection(db, 'lessons'), lId))
    }
  }
  await batch.commit()
}

export const dbDuplicateConference = async (
  c: IConference,
  lessons: Record<string, ILesson>
) => {
  const batch = writeBatch(db)
  const newId = generateId()
  const newConference: IConference = {
    ...c,
    id: newId,
    lessons: [],
    createdAt: +dayjs(),
    title: c.title + ' (copy)',
    copyOf: {
      entityId: c.id,
      entityType: IEntityType.CONFERENCES
    }
  }
  if (c.lessons) {
    for (const lId of c.lessons) {
      const l = lessons[lId]
      if (l) {
        const newL: ILesson = {
          ...l,
          id: generateId(),
          entityId: newId
        }
        newConference.lessons.push(newL.id)
        batch.set(doc(collection(db, 'lessons'), newL.id), newL)
      }
    }
  }

  batch.set(doc(collection(db, 'conferences'), newId), newConference)
  await batch.commit()
  return newId
}
